module.exports = __webpack_public_path__ + "static/media/bhel.31625235.png";